// extracted by mini-css-extract-plugin
module.exports = {"root":"List_root__1clTB","list":"List_list__2_a6W","item":"List_item__1Ulgd"};